import { render, staticRenderFns } from "./ProjectDroppedDisabilitiesTable.vue?vue&type=template&id=f95ad7c4&"
import script from "./ProjectDroppedDisabilitiesTable.vue?vue&type=script&lang=js&"
export * from "./ProjectDroppedDisabilitiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports